"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParserError = void 0;
const util_1 = require("util");
class ParserError extends Error {
    constructor(message) {
        super(util_1.format('Parse error: %s', message));
    }
}
exports.ParserError = ParserError;
//# sourceMappingURL=ParserError.js.map